'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

import Button from '@/components/button';
import Typography from '@/components/typography';
import { HOME_URL } from '@/constants/constantUrls';

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    // eslint-disable-next-line jsx-a11y/html-has-lang
    <html>
      <body>
        <div className="relative h-[100vh]">
          <div className="flex h-full flex-col place-content-center items-center text-gray-100">
            <img alt="error" className="mx-auto" src="/img/error-img.png" />
            <Typography className="text-center" variant="h1">
              Oops!
            </Typography>
            <Typography className="mt-[32px] text-center">
              There is a mistake on our end.
              <br />
              Please refresh your browser or go to another page.
            </Typography>
            <Button
              className="mt-[41px] px-[30px]"
              onClick={() => {
                window.location.href = HOME_URL;
              }}
            >
              Home
            </Button>
          </div>
        </div>
      </body>
    </html>
  );
}
